import { IoIosArrowRoundUp } from "react-icons/io";
import { ReactNode } from "react";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { LANG } from "@/types";
import { Box, Typography } from "@mui/material";

export const StaticDashboard = ({
  title,
  subTitle,
  logo,
  percentage,
}: {
  day: string;
  title: string;
  subTitle: number | string;
  logo: ReactNode;
  percentage: string;
}) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);

  return (
    <Box
      dir={locale === LANG.AR ? "rtl" : "ltr"}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: { xs: 2, sm: 3 },
        color: "#1e293b",
        position: "relative",
      }}
    >
      {/* Main Content */}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Box
          sx={{
            flex: 1,
            borderRadius: 1,
            borderLeft: locale === LANG.EN ? "5px solid #644980" : "",
            borderRight: locale === LANG.AR ? "5px solid #644980" : "",
            pl: 3,
            pr: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 500,
              fontSize: { xs: "0.875rem", sm: "1rem" },
              color: "#64748b",
              mb: 1,
              lineHeight: 1.2,
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 600,
              fontSize: { xs: "1.75rem", sm: "2.25rem", md: "2.5rem" },
              color: "#1e293b",
              lineHeight: 1,
            }}
          >
            {subTitle || "0"}
          </Typography>
        </Box>

        {/* Right Side - Icon */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: { xs: 48, sm: 56 },
            height: { xs: 48, sm: 56 },
            borderRadius: 2,
            background: "#f0deee",
          
            flexShrink: 0,
          }}
        >
          <Box
            sx={{
              color: "#644980",
              fontSize: { xs: "1.5rem", sm: "1.75rem" },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {logo}
          </Box>
        </Box>
      </Box>

      {/* Bottom Section - Stats */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          padding: "6px 10px",
          borderRadius: 1.5,
          background: "#f8fafc",
          
          alignSelf: "flex-start",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: "#059669",
              fontSize: "0.875rem",
            }}
          >
            {percentage}
          </Typography>
          <IoIosArrowRoundUp />
        </Box>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            color: "#64748b",
            fontSize: "0.75rem",
          }}
        >
          {t("time.lastWeek")}
        </Typography>
      </Box>
    </Box>
  );
};
